'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import ky from 'ky';
import { API_ROUTES } from '@/constants';
import { useAdvertisingId } from '@/modules/wello-app';
export interface CoupangRecommendProduct {
  isRocket: boolean;
  productImage: string;
  productName: string;
  productPrice: number;
  clickUrl: string;
}
interface CoupangRecommendResponse {
  products: CoupangRecommendProduct[];
}
const STALE_TIME_MS = 1000 * 60 * 60;
export const useCoupangRecommend = () => {
  const $ = _c(16);
  const {
    advertisingId,
    platform,
    isPending
  } = useAdvertisingId();
  let t0;
  if ($[0] !== advertisingId) {
    t0 = ["coupang-recommend", advertisingId];
    $[0] = advertisingId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== advertisingId || $[3] !== platform) {
    t1 = () => ky.get(API_ROUTES.COUPANG_RECOMMEND.withSearchParams({
      searchParams: platform === "ios" ? {
        idfa: advertisingId ?? ""
      } : {
        adid: advertisingId ?? ""
      }
    })).json();
    $[2] = advertisingId;
    $[3] = platform;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = !!advertisingId;
  let t3;
  if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      staleTime: STALE_TIME_MS,
      enabled: t2
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    data,
    isLoading
  } = useQuery(t3);
  let t4;
  if ($[9] !== data?.products) {
    t4 = data?.products ?? [];
    $[9] = data?.products;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== advertisingId || $[12] !== isLoading || $[13] !== isPending || $[14] !== t4) {
    t5 = {
      products: t4,
      isLoading,
      advertisingId,
      isAdvertisingIdPending: isPending
    };
    $[11] = advertisingId;
    $[12] = isLoading;
    $[13] = isPending;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};